import React,{useState, useRef, useEffect, memo} from "react";
import AudioPlayer from "react-h5-audio-player";
import {Spinner} from 'reactstrap';

import 'react-h5-audio-player/lib/styles.css';

const Mp3Player = ({src}) => {
  const audioRef = useRef();
  const [isPlaying, setIsPlaying] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState(false);
  
  useEffect(() => {
    return () => {
      console.log("Aborted");
      setIsPlaying(false);
      audioRef && audioRef?.current?.handleAbort()
      // audioRef.current.audio.current.abort();
    };
  }, []);
  
  return (
    <div style={{ position: "relative" }}>
      <AudioPlayer
        ref={audioRef}
        autoPlay={false}
        autoPlayAfterSrcChange={false}
        src={src}
        onPlay={(e) => setIsPlaying(true)}
        onCanPlayThrough={(e) => setIsDownloaded(true)}
        onPause={(e) => setIsPlaying(false)}
      />
      {isPlaying && !isDownloaded && (
        <>
        <div style={{position:'absolute',top:0,width:'100%',height:'100%',backgroundColor:'#EBEBE4',opacity:'0.5'}} />
        <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translateY(-50%) translateX(-50%)",
              opacity: '1 !important'
            }}
          >
            <Spinner color="#483a3a" >Loading...</Spinner>
          </div>
        </>
      )}
    </div>
  );
};

export default memo(Mp3Player);
